import { useReactFlow } from '@xyflow/react';
import { ISelectorNode } from '@topshots/core-models';
import { Button, ButtonTier } from 'shared-components';
import styles from './tree-navigator.module.css';

interface TreeNavigatorProps {
  nodes: ISelectorNode[];
  rootNodeId: string;
  selectedNodeId: string | null;
  onSelectNode: (nodeId: string) => void;
  onAddNode: () => void;
  disabled: boolean;
}

export const TreeNavigator = ({
  nodes,
  rootNodeId,
  selectedNodeId,
  onSelectNode,
  onAddNode,
  disabled,
}: TreeNavigatorProps) => {
  const reactFlow = useReactFlow();

  const handleNodeClick = (nodeId: string) => {
    onSelectNode(nodeId);
    reactFlow.fitView({
      nodes: [{ id: nodeId }],
      duration: 300,
      padding: 0.5,
    });
  };

  return (
    <div className={styles.navigator}>
      <div className={styles.title}>Questions</div>
      <div className={styles.nodeList}>
        {nodes.map((node) => (
          <button
            key={node.id}
            className={`${styles.nodeItem} ${selectedNodeId === node.id ? styles.active : ''}`}
            onClick={() => handleNodeClick(node.id)}
          >
            <span className={styles.nodePrompt}>
              {node.prompt || 'Untitled question'}
            </span>
            {node.id === rootNodeId && (
              <span className={styles.rootBadge}>Start</span>
            )}
          </button>
        ))}
      </div>
      <div className={styles.actions}>
        <Button
          tier={ButtonTier.Secondary}
          onClick={onAddNode}
          disabled={disabled}
        >
          Add Question
        </Button>
      </div>
    </div>
  );
};
